
import { Notification } from 'element-ui';
import Vue from 'vue'

/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
export const getStore = name => {
    if (!name) return;
    return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
        if (!name) return;
        window.localStorage.removeItem(name);
    }
    /**
     * 存储sessionStorage
     */
export const setStoreSession = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.sessionStorage.setItem(name, content);
}

/**
 * 获取sessionStorage
 */
export const getStoreSession = name => {
    if (!name) return;
    return window.sessionStorage.getItem(name);
}

/**
 * 删除sessionStorage
 */
export const removeStoreSession = name => {
    if (!name) return;
    window.sessionStorage.removeItem(name);
};

// 用户缓存，避免重复读取缓存
const CACHED = {}

// 设置缓存
const setCache = (key, val) => {
    CACHED[key] = val

    return storage.setItem(key, val)
}

// 获取缓存
const getCache = key => {
    if (CACHED[key]) {
        return CACHED[key]
    }

    CACHED[key] = storage.getItemSync(key)

    return CACHED[key]
}

// 移除缓存
const removeCache = key => {
    delete CACHED[key]

    return storage.removeItem(key)
}

/**
 * 生成全局唯一标识
 */
const generateUUID = () => {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
};
let deviceId = generateUUID()

// 唯一标识 是否生成
let deviceIdIs = () => {
    if (!getStore('deviceId')) {
        setStore('deviceId', deviceId)
    } else {
        getStore('deviceId')
    }
}

/**
 * 获取缓存中的token（同步）
 * @return {string} token
 */
// export const getToken = () => getCache(KEYS.TOKEN_KEY)

/**
 * 将token保存到缓存中(同步)
 * @param  {string} token
 * @return {undefined}
 */
// export const saveToken = val => setCache(KEYS.TOKEN_KEY, val)

/**
 * @date Date类型对象
 * @fmt 格式化字符串  月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
 *                   年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * 例子：
 * dateformat(new Date(), "yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
 * dateformat(new Date(), "yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
 */
export const dateformat = (date, fmt) => {
    var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

/**
 * 获取一周内的时间
 * @containToday: Boolean，默认值true，表示返回日期包含今天，否则返回日期截止到昨天
 * 例子：比如今天是'2018-07-08'
 * getWeeks();       // return ['2018-07-02', '2018-07-08']
 * getWeeks(false);  // return ['2018-07-01', '2018-07-07']
 */
export const getWeeks = (containToday) => {
    let weeks = [];
    let now = '';
    if (containToday === false) {
        now = new Date(getDateStr(-1));
    } else {
        now = new Date();
    }
    let lastweek = new Date(now.getTime() - 6 * 24 * 60 * 60 * 1000);
    weeks.push(dateformat(lastweek, 'yyyy-MM-dd'), dateformat(now, 'yyyy-MM-dd'));
    return weeks;
}

export const getWeeksAll = (containToday) => {
  let weeks = [];
  let now = '';
  if (containToday === false) {
    now = new Date(getDateStr(-1));
  } else {
    now = new Date();
  }
  let lastweek = new Date(now.getTime() - 6 * 24 * 60 * 60 * 1000);
  weeks.push(dateformat(lastweek, 'yyyy-MM-dd hh:mm:ss'), dateformat(now, 'yyyy-MM-dd hh:mm:ss'));
  return weeks;
}
/**
 * 获取nMonths月内的时间, nMonths默认为1
 * @containToday: Boolean，默认值true，表示返回日期包含今天，否则返回日期截止到昨天
 * 例子：比如今天是'2018-07-08'
 * getMonths();  // return ['2018-06-08', '2018-07-08']
 * getMonths(false);  // return ['2018-06-07', '2018-07-07']
 * getMonths(true, 2);  // return ['2018-05-08', '2018-05-08']
 */
export const getMonths = (containToday, nMonths = 1) => {
    let months = [];
    let now = '';
    if (containToday === false) {
        now = new Date(getDateStr(-1));
    } else {
        now = new Date();
    }
    months.push(dateformat(now, 'yyyy-MM-dd'));
    let lastmonth = new Date(now.setMonth(now.getMonth() - nMonths));
    months.push(dateformat(lastmonth, 'yyyy-MM-dd'));
    return months.reverse();
}

export const getMonthsAll = (containToday, nMonths = 1) => {
  let months = [];
  let now = '';
  if (containToday === false) {
    now = new Date(getDateStr(-1));
  } else {
    now = new Date();
  }
  months.push(dateformat(now, 'yyyy-MM-dd hh:mm:ss'));
  let lastmonth = new Date(now.setMonth(now.getMonth() - nMonths));
  months.push(dateformat(lastmonth, 'yyyy-MM-dd hh:mm:ss'));
  return months.reverse();
}
/**
 * 获取一年内的时间
 * 返回值数组 arr[0]：一年前的那天，arr[1]：今天
 * 例子：
 * getWeeks();  // return ['2017-07-08', '2018-07-08']
 */
export const getYears = () => {
    let years = [];
    let now = new Date();
    years.push(dateformat(now, 'yyyy-MM-dd'));
    let lastmonth = new Date(now.setFullYear(now.getFullYear() - 1));
    years.push(dateformat(lastmonth, 'yyyy-MM-dd'));
    return years.reverse();
}

/**
 * 获取自然年
 * 返回值数组 arr[0]：今年的1月1号，arr[1]：今天
 * 例子：
 * getWeeks();  // return ['2018-07-08', '2018-07-08']
 */
export const getNaturalYears = () => {
    let years = [];
    let now = new Date();
    years.push(dateformat(now, 'yyyy-MM-dd'));
    let lastmonth = now.getFullYear()+ '-01-01'
    years.push(lastmonth);
    return years.reverse();
}
/**
 * 今年到明天
 *
 */
 export const getNaturalYearsAddOneday = () => {
    let years = [];
    let now = new Date(new Date().getTime()+24 * 60 * 60 * 1000);
    years.push(dateformat(now, 'yyyy-MM-dd'));
    let lastmonth = now.getFullYear()+ '-01-01'
    years.push(lastmonth);
    return years.reverse();
}
/**
 * 今年年初到年尾
 *
 */
 export const getFullYearByTime = () => {
    let now = new Date();
    let year = now.getFullYear()
    return [year+'-01-01',year+'-12-31'];
}
export const getYearsAll = () => {
  let years = [];
  let now = new Date();
  years.push(dateformat(now, 'yyyy-MM-dd hh:mm:ss'));
  let lastmonth = new Date(now.setFullYear(now.getFullYear() - 1));
  years.push(dateformat(lastmonth, 'yyyy-MM-dd hh:mm:ss'));
  return years.reverse();
}
/**获取当前URL里的查询参数
 *
 * @param url
 * @returns {{}|*}
 */
export const getUrlParams = url => {
    url = url || window.location.href;
    let queryArray = url.split(/[?&#]/).slice(1);
    let i;
    let args = {};
    for (i = 0; i < queryArray.length; i++) {
        var match = queryArray[i].match(/([^=]+)=([^=]+)/);
        if (match !== null) {
            args[match[1]] = decodeURIComponent(match[2]);
        }
    }
    return args;
}

export const getdeviceId = () => deviceIdIs()

/**
 * 获取相对于今天的日期
 * dayCount = -1 表示昨天，dayCount = 0 表示今天，dayCount = 1 表示明天
 * 例子：
 * getDateStr(-1);  // return '2018-11-18'
 */
export const getDateStr = dayCount => {
    if (null == dayCount) {
        dayCount = 0;
    }
    let date = new Date();
    date.setDate(date.getDate() + dayCount);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();
    return y + "-" + m + "-" + d;
}

/**
 * 获取相对于今天的日期
 * dayCount = -1 表示昨天，dayCount = 0 表示今天，dayCount = 1 表示明天
 * 例子：
 * getDateStr(-1);  // return '2018-11-18'
 */
export const getDateStrs = dayCount => {
    if (null == dayCount) {
        dayCount = 0;
    }
    let date = new Date();
    date.setDate(date.getDate() + dayCount);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();
    if (m < 10) {
        m = `0${m}`
    }
    if (d < 10) {
        d = `0${d}`
    }
    return y + "-" + m + "-" + d;
}
/**
 * 根据name获取cookie的值
 * 例子：假设 document.cookie = 'age=18; name=ccp; sex=male'
 * getCookieByName('name');  // return 'ccp'
 */
export const getCookieByName = name => {
        if (!name) {
            return;
        }
        let cookies = document.cookie.split('; ');
        let ret = '';
        for (let i = 0, l = cookies.length; i < l; i++) {
            var match = cookies[i].match(/([^=]+)=([^=]+)/);
            if (match !== null && match[1] === name) {
                ret = decodeURIComponent(match[2]);
                break;
            }
        }
        return ret;
    }
    //把对象中的null转换为0
export const changeToZero = (data) => {
    for (let x in data) {
        if (data[x] === null) {
            data[x] = 0;
        } else {
            if (Array.isArray(data[x])) {
                data[x] = data[x].map(z => {
                    return changeToZero(z);
                });
            }
            if (typeof(data[x]) === 'object') {
                data[x] = changeToZero(data[x])
            }
        }
    }
    return data;
}

export const changeTostr = data => {
    for (let x in data) {
        if (data[x] === null) {
            data[x] = '';
        } else {
            if (Array.isArray(data[x])) {
                data[x] = data[x].map(z => {
                    return changeTostr(z);
                });
            }
            if (typeof(data[x]) === 'object') {
                data[x] = changeTostr(data[x])
            }
        }
    }
    return data;
}

// 获取用户当前登录的身份角色
export const getRole = () => {
    if (getStoreSession('haslogin') === 'yes') {
        let logininfo = JSON.parse(getStore('loginInfo'));
        let data = {}
        logininfo.userRoles.forEach((item) => {
            if (item.selected) {
                // 判断是否是用户
                if (item.roleCode === 'COMMON_ROOT') {
                    data = {
                        roleCode: '',
                        rootRoleCode: 'COMMON_ROOT',
                        roleName: item.roleName,
                        roleType: item.roleType
                    }
                } else {
                    item.subAuthRoles.forEach((items) => {
                        if (items.selected) {
                            data = {
                                roleCode: items.roleCode,
                                rootRoleCode: 'WORKER_ROOT',
                                roleName: items.roleName,
                                roleType: items.roleType
                            }
                        }
                    })
                }
            }
        })
        return data;
    }
}
export function importAll(modulesContext) {
    return modulesContext.keys().map((modulesPath) => {
        const moduleName = modulesPath.match(
            /^\.\/([^\s]+)\.js$/
        )
        return {
            moduleName,
            camelModuleName: moduleName[1].replace(
                /-(\w)/g,
                (_, c) => (c ? c.toUpperCase() : '')
            ),
            module: modulesContext(modulesPath).default
        }
    })
}
// 深拷贝对象
export function deepClone(obj) {
    const _toString = Object.prototype.toString

    // null, undefined, non-object, function
    if (!obj || typeof obj !== 'object') {
      return obj
    }

    // DOM Node
    if (obj.nodeType && 'cloneNode' in obj) {
      return obj.cloneNode(true)
    }

    // Date
    if (_toString.call(obj) === '[object Date]') {
      return new Date(obj.getTime())
    }

    // RegExp
    if (_toString.call(obj) === '[object RegExp]') {
      const flags = []
      if (obj.global) { flags.push('g') }
      if (obj.multiline) { flags.push('m') }
      if (obj.ignoreCase) { flags.push('i') }

      return new RegExp(obj.source, flags.join(''))
    }

    const result = Array.isArray(obj) ? [] : obj.constructor ? new obj.constructor() : {}

    for (const key in obj) {
      result[key] = deepClone(obj[key])
    }

    return result
  }

  // license提示
  export function showLicenseNotifyMsg(msg, immediatelyJump)  {
    // 跳转到License界面
    var jumpToLicense = function() {
        // 未登录
        if (getStoreSession('haslogin') != 'yes') {
            Vue.prototype.$message({
                type: 'error',
                message: '请先登录'
            })
        }
        // 判断是否有权限申请license
        let currentUserRole = Vue.prototype.$localStorage.userRoles.find((item)=>{return item.selected})
        if (currentUserRole && currentUserRole.roleCode === 'COMMON_ROOT') {
            let paths = document.location.href.split('/').reverse()
            if ((paths.length == 4 && paths[0] != '') || paths.length > 4) {
                // 非首页
                document.location.href = '/'
            }
        } else {
            let authRoleAcls =  Vue.prototype.$localStorage.authRoleAcls
            if (!authRoleAcls) {
                let paths = document.location.href.split('/').reverse()
                if ((paths.length == 4 && paths[0] != '') || paths.length > 4) {
                    // 非首页
                    document.location.href = '/'
                }
            } else {
                let canJump = false
                authRoleAcls.forEach(item => {
                    if (item.parent.aclRouter == '/admin/licenseCodeList/apply') {
                        canJump = true
                    } else if (item.child && item.child[0]) {
                        item.child.forEach(subItem => {
                            if (subItem.aclRouter == '/admin/licenseCodeList/apply') {
                                canJump = true
                            }
                        })
                    }
                })
                if (canJump) {
                    if (document.location.href.indexOf('/admin/licenseCodeList/apply') == -1) {
                        document.location.href = '/admin/licenseCodeList/apply'
                    }
                } else {
                    let paths = document.location.href.split('/').reverse()
                    if ((paths.length == 4 && paths[0] != '') || paths.length > 4) {
                        // 非首页
                        document.location.href = '/'
                    }
                }
            }
        }
    }
    // 展示顶部提示语
    Notification.closeAll()
    Vue.prototype.$notify({
        message: msg,
        duration: 0,
        offset: 20,
        customClass: 'license-notify',
        showClose:  true,
        onClick: () => {
            jumpToLicense()
        },
    });
    // 是否立即执行跳转
    if (immediatelyJump) {
        jumpToLicense()
    }
}

/**
 * @function createQRCode
 * @description 生成二维码
 * @return {promise} promise promise
 * */
let facialVerifyUUID

export function getFacialVerifyUUID() {
    return facialVerifyUUID
}
